import type { LinkTokens } from './types';

export const link: LinkTokens = {
  borderStyles: {
    base: 'none',
    underlined: 'solid',
    legal: 'none',
    legalHover: 'solid',
    legalUnderline: 'solid',
    legalUnderlineHover: null,
    disabled: 'none',
  },
  borderWidths: {
    underlined: '1px',
    legal: null,
    legalHover: '1px',
    legalUnderline: '1px',
    legalUnderlineHover: null,
    disabled: null,
  },
  colors: {
    underlinedBorder: 'neutrals.0',
    legalBorder: null,
    disabledBorder: null,
  },
  textDecoration: {
    legalHover: 'none',
  },
};
